import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import styles from "../DescriptionTabs.module.scss";
import { useTranslation } from "react-i18next";

const DocumentsTable = ({ documents, translateKey }) => {
    const { t } = useTranslation();

    return (
        <>
            <Table className={styles.documentsTable} sx={{ fontFamily: "Montserrat !important" }}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontFamily: "Montserrat !important" }}>{t(`${translateKey}-text-title`)}</TableCell>
                        <TableCell sx={{ fontFamily: "Montserrat !important" }}>{t(`${translateKey}-text-description`)}</TableCell>
                        <TableCell sx={{ fontFamily: "Montserrat !important" }}>{t(`${translateKey}-text-document`)}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(documents ?? []).map((document) => {
                        return (
                            <TableRow key={document.id}>
                                <TableCell sx={{ fontFamily: "Montserrat !important" }}>{document?.title ?? document?.file_filename}</TableCell>
                                <TableCell sx={{ fontFamily: "Montserrat !important" }}>{document?.description}</TableCell>
                                <TableCell sx={{ fontFamily: "Montserrat !important" }}>
                                    <a href={document?.file} target="_blank" rel="noreferrer" download>
                                        {t(`${translateKey}-text-download`)}
                                    </a>
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </>
    );
};

const DocumentsTab = ({ technicalDoc, instructionDoc, certificateDoc, translateKey }) => {
    const { t } = useTranslation();
    return (
        <Box className={styles.tabContent} sx={{ fontFamily: "Montserrat !important" }}>
            {technicalDoc.length > 0 && (
                <>
                    <h6 className={styles.tabTitle}>{t(`${translateKey}-text-technical_documentation`)}</h6>
                    <Box className={styles.tabSection}>
                        <DocumentsTable documents={technicalDoc} translateKey={translateKey} />
                    </Box>
                </>
            )}
            {instructionDoc.length > 0 && (
                <>
                    <h6 className={styles.tabTitle}>{t(`${translateKey}-text-instructions`)}</h6>
                    <Box className={styles.tabSection}>
                        <DocumentsTable documents={instructionDoc} translateKey={translateKey} />
                    </Box>
                </>
            )}
            {certificateDoc.length > 0 && (
                <>
                    <h6 className={styles.tabTitle}>{t(`${translateKey}-text-certificates`)}</h6>
                    <Box className={styles.tabSection}>
                        <DocumentsTable documents={certificateDoc} translateKey={translateKey} />
                    </Box>
                </>
            )}
        </Box>
    );
};

export default DocumentsTab;
